import type { FaireProductEntity } from "../../entity_types/product";

export const p_nwzfzqnzxc: FaireProductEntity = {
  token: "p_nwzfzqnzxc",
  type: "product",
  name: "REM Sleep",
  brandToken: "b_30207947",
  brandName: "HealthyCell",
  imageUrl:
    "https://cdn.faire.com/fastly/d799953cb59d3471e451b413d3f898a2bbfa054f07856fde5d633504efb09dc8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ed607faf9593b4532045c16e1f275c1b91c39d037559f0b62d0cad5e24cfaa03.jpeg",
    "https://cdn.faire.com/fastly/9ba3874471035802e22cc563ad337c7ec729d89867434fee78a315f0239ce6ac.jpeg",
    "https://cdn.faire.com/fastly/78192bdefbb2a38eb97e8ac24a056ba3933880068670d8e56c960ec7059098a6.jpeg",
    "https://cdn.faire.com/fastly/56ee5600e0dfdbba434125d0774fc5d6ff472b8b17f717b1a4060a3871b29872.jpeg",
    "https://cdn.faire.com/fastly/3e365cb2f6a16b739e7f33a26d0e8411220d1c6bceffda149904faa8d51f1b2c.jpeg",
  ],
  priceDollars: 20.39,
  description:
    "\nCalming herbs, amino acids, and natural, non-habit-forming ingredients support all four stages of sleep in this soothing cherry MicroGel™ that helps you wake refreshed and ready to seize the day.†\n\n--> Soothe the mind and body to sleep faster†\n--> Optimize sleep cycles to promote deep, longer-lasting sleep †\n--> Support sleep hormone regulation†\n\n4 x 14-serving boxes per case.\n",
  tags: [],
  msrpDollars: 41.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:36.793Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
